"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newMessage = exports.INBOX_NEW_MESSAGE = void 0;
var INBOX_NEW_MESSAGE = "inbox/NEW_MESSAGE";
exports.INBOX_NEW_MESSAGE = INBOX_NEW_MESSAGE;

var newMessage = function newMessage(message) {
  return {
    type: INBOX_NEW_MESSAGE,
    payload: message
  };
};

exports.newMessage = newMessage;